import "react";
import { jsx as e } from "react/jsx-runtime";
//#region src/components/atoms/Icon/SVGs/keep.svg
var t = (t) => /* @__PURE__ */ e("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...t,
	children: /* @__PURE__ */ e("path", {
		fill: "#1f2830",
		d: "M11.333 1.612v5.642l1.417 1.37a.8.8 0 0 1 .25.585v.464q0 .342-.24.574a.82.82 0 0 1-.593.232H8.833v4.715q0 .342-.24.574A.82.82 0 0 1 8 16a.82.82 0 0 1-.594-.232.77.77 0 0 1-.24-.574v-4.715H3.834a.82.82 0 0 1-.593-.232.77.77 0 0 1-.24-.574v-.464a.8.8 0 0 1 .25-.584l1.417-1.37V1.611a.82.82 0 0 1-.594-.232.77.77 0 0 1-.24-.574q0-.342.24-.574A.82.82 0 0 1 4.667 0h6.666a.82.82 0 0 1 .594.232q.24.232.24.574 0 .343-.24.574a.82.82 0 0 1-.594.232"
	})
});
//#endregion
export { t as default };
